import { useAuth } from "domain/authentication";
import { Navigate } from "react-router-dom";
import { routes } from "router";

export const SignOut = () => {
  const { logOut } = useAuth();

  logOut();

  return <Navigate to={routes.SIGNIN} replace />;
};
